import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-page-principal',
  templateUrl: './home-page-principal.component.html',
  styleUrls: ['./home-page-principal.component.scss']
})
export class HomePagePrincipalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
